import { useToastStore } from "../stores/toast";

/**
 * Extracts a user-facing message from a structured API error and pushes it to
 * the toast store.
 *
 * The backend may return a `translation` object with an i18n key and
 * interpolation args. When present, we attempt to translate it. If the i18n
 * library returns the key unchanged (meaning the key is missing), we fall back
 * to the plain-English `human` field. If neither is available, we show a
 * generic error message.
 *
 * @param {object|null} error - Superagent error response (`e.response`).
 * @param {function} t - i18next translation function.
 */
export function showApiError(error, t) {
  try {
    // FastAPI wraps HTTPException detail in {"detail": {...}}
    const body = error?.body?.detail ?? error?.body;
    const translation = body?.translation;

    if (translation?.id && translation?.args) {
      const translated = t(translation.id, translation.args);
      // i18n returns the key itself when the translation is missing
      if (translated !== translation.id) {
        useToastStore.getState().addToast("error", translated);
        return;
      }
    }

    if (body?.human) {
      useToastStore.getState().addToast("error", body.human);
      return;
    }

    useToastStore.getState().addToast("error", t("errors.unknown"));
  } catch {
    useToastStore.getState().addToast("error", t("errors.unknown"));
  }
}
